export const gitInfo = { commitHash: "bb0bef3", version: "bb0bef3" };
